module.exports = __webpack_public_path__ + "media/images/approve_request-b3cb18b1.svg";